(function () {
  function parsePrice(text) {
    if (!text) return null;
    text = text.replace(/[^\d.,]/g, "");
    if (text.indexOf(",") > -1 && text.indexOf(".") > -1) {
      text = text.replace(/,/g, "");
    }
    text = text.replace(",", ".");
    return parseFloat(text);
  }

  function formatPrice(num) {
    return (
      num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + "TL"
    );
  }

  function addProductDiscount() {
    // ShopifyAnalytics kontrolü
    if (
      typeof ShopifyAnalytics === "undefined" ||
      ShopifyAnalytics.meta.page.pageType !== "product"
    ) {
      return;
    }

    // Etiket kontrolü
    if (
      typeof window.productTags === "undefined" ||
      !window.productTags.includes("outlet")
    ) {
      return; // outlet yoksa işlem yapma
    }

    const priceBox = document.querySelector(
      "#price-template--16754820382822__main .price.price--on-sale"
    );
    if (!priceBox) return;

    priceBox.style.display = "flex";
    priceBox.style.flexDirection = "column";

    // Tekrar eklenmemesi için
    if (priceBox.querySelector(".extra-discount-info")) return;

    const salePriceEl = priceBox.querySelector(".price-item--sale bdi");
    if (!salePriceEl) return;

    const salePrice = parsePrice(salePriceEl.textContent);
    if (isNaN(salePrice)) return;

    const discounted = salePrice * 0.8; // %20 indirim

    const discountDiv = document.createElement("div");
    discountDiv.className = "extra-discount-info";
    discountDiv.style.color = "#e6e8dc";
    discountDiv.style.background = "#556360";
    discountDiv.style.fontWeight = "600";
    discountDiv.style.marginTop = "5px";
    discountDiv.style.marginBottom = "5px";
    discountDiv.style.fontSize = "15px";
    discountDiv.style.letterSpacing = "normal";
    discountDiv.style.padding = "5px";
    discountDiv.style.borderRadius = "4px";
    discountDiv.textContent = `Sepette %20 indirim: ${formatPrice(discounted)}`;

    priceBox.appendChild(discountDiv);
  }

  // Element yüklenene kadar bekle
  const initInterval = setInterval(() => {
    if (
      document.querySelector(
        "#price-template--16754820382822__main .price.price--on-sale"
      )
    ) {
      clearInterval(initInterval);
      addProductDiscount();
    }
  }, 300);
})();
